
import vue from "../adapter-vue";
import { customerServicePayloadType } from "../interface";

const { ref, watchEffect, onBeforeUnmount, onMounted } = vue;

interface Props {
  payload: customerServicePayloadType;
}

export default {
  props: {
    payload: {
      type: Object as () => customerServicePayloadType,
      default: () => ({}),
    },
  },
  setup(props: Props) {
    const content = ref<string>("");
    const displayedContent = ref<string>("");
    const isFinished = ref<boolean>(false);
    let intervalId: number | null = null;
    let currentIndex = 0;

    const updateDisplayedContent = () => {
      if (intervalId) {
        window.clearInterval(intervalId);
      }
      intervalId = window.setInterval(() => {
        if (currentIndex < content.value.length) {
          displayedContent.value += content.value[currentIndex];
          currentIndex++;
        } else {
          window.clearInterval(intervalId!);
          intervalId = null;
        }
      }, 50);
    };

    onMounted(() => {
      content.value = props?.payload?.chunks?.join("") ?? "";
      displayedContent.value = content.value;
      currentIndex = content.value.length;
    });

    watchEffect(() => {
      const newContent = props?.payload?.chunks?.join("") ?? "";
      if (newContent.length > currentIndex) {
        content.value = newContent;
        updateDisplayedContent();
      }
    });

    watchEffect(() => {
      isFinished.value = props?.payload?.isFinished === 1;
    });

    onBeforeUnmount(() => {
      if (intervalId) {
        window.clearInterval(intervalId);
      }
    });

    return {
      content,
      props,
      isFinished,
      displayedContent,
    };
  },
};
